import { isPlainObject, pick } from 'lodash'
import QueryString from 'qs'
import { apiClient } from '../client'
import { fetchFormValues } from '../../utils/formUtils/forms'
import { PageListParams } from '../globalTypes'
import { CONTACT_VALUE_ENDPOINTS, ENDPOINT_FILTERS } from './formValuesConfig'
import { ContactCriteria, ContactParams, ContactPayload, ContactPropertyTransactionListResponse, ContactValuesData } from './types'

export const getContactById = async (id: string, params: ContactParams = {}) => {
    const response = await apiClient(`v1/contact/${id}`, {
        params,
        paramsSerializer: (params: ContactParams) => {
            const criteria = isPlainObject(params.criteria) ? params.criteria : {}
            const paramsWithValidCriteria = { ...params, criteria }
            return QueryString.stringify(paramsWithValidCriteria)
        },
    })

    return response.data
}

export const getCompanyById = async (id: string, params: ContactParams = {}) => {
    const response = await apiClient(`v1/contact/${id}`, {
        params,
        paramsSerializer: (params: ContactParams) => {
            const criteria = isPlainObject(params.criteria) ? params.criteria : {}
            const paramsWithValidCriteria = { ...params, criteria }
            return QueryString.stringify(paramsWithValidCriteria)
        },
    })

    return response.data
}

export const getContacts = async (payload: PageListParams<ContactCriteria>) => {
    const response = await apiClient(`v1/contact`, {
        params: payload,
        paramsSerializer: (params: PageListParams<ContactCriteria>) => {
            const criteria = isPlainObject(params.criteria) ? params.criteria : {}
            const paramsWithValidCriteria = { ...params, criteria }
            return QueryString.stringify(paramsWithValidCriteria)
        },
    })

    return response.data
}

export const getContactPropertyTransactions = async (contactId: number): Promise<ContactPropertyTransactionListResponse> => {
    const response = await apiClient(`v1/property-transaction/${contactId}`)

    return response.data
}

export const createUpdateContact = async (payload: ContactPayload) => {
    const { isEdit, data, contactType, id } = payload

    if (isEdit && !id) {
        throw new Error('Contact id is required for update')
    }

    const url = isEdit ? `v1/contact/${id}` : `v1/contact/${contactType}`

    const response = await apiClient(url, {
        method: isEdit ? 'PUT' : 'POST',
        data,
    })

    return response.data
}

export const deleteContactById = async (id: number) => {
    const response = await apiClient(`v1/contact/${id}`, {
        method: 'DELETE',
    })

    return response.data
}

export const deleteContacts = async (ids: number[]) => {
    const response = await apiClient('v1/contact', {
        method: 'DELETE',
        data: {
            ids,
        },
    })

    return response.data
}

export const fetchContactValues = (fields?: string[], formFilters?: Record<string, string | string[]>) => {
    const endpoints = fields ? pick(CONTACT_VALUE_ENDPOINTS, fields) : CONTACT_VALUE_ENDPOINTS

    return fetchFormValues<ContactValuesData>(endpoints, formFilters, ENDPOINT_FILTERS)
}
